import React, { useEffect } from "react";
import Title from "../../new-components/title/Title";
import { useLocation, useParams } from "react-router-dom";
import Overllay from "../../assets/new_imgs/Rectangle 1072.png";
import NewFooter from "../../NewFooter";
import "../food-and-beverages/FoodAndBeverages.scss";
import { trackCategoryViewed } from "../../utils/mixpanel";
import { isClosedNow } from "../../utils/availability";
import ClosableLink from "../../new-components/closed-badge/ClosableLink";
import housekeepingImage from "../../assets/new_imgs/Housekeeping.png";
import receptionImage from "../../assets/new_imgs/Reception.png";
import laundryImage from "../../assets/new_imgs/Laundry.png";

const HotelServices = () => {
  const params = useParams();
  const lang = sessionStorage.getItem("lang");
  const location = useLocation();
  const metadata = location.state?.metadata;
  const countryCode = localStorage.getItem("countryCode");
  const isSaudi = countryCode?.toUpperCase() === "SA";
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
    });
  }, []);

  console.log("metadata", metadata);

  return (
    <div className={`food ${lang === "AR" && "arabic"}`}>
      <Title title={"Hotel Services"} />

      <div className="box_food image_services">
        {metadata?.map((service) => {
          // if (service.id === 18) {
          //   return (
          //     <Link to={`/${params.room_uuid}/hotel-services/salon`}>
          //       <img
          //         src={"https://d3l5wxnahfuscp.cloudfront.net/static/salon.png"}
          //         alt=""
          //         className="service_img"
          //       />
          //       <img src={Overllay} alt="" className="overlay" />
          //       <h6 className="sub_title">{service?.display_name}</h6>
          //     </Link>
          //   );
          // }

          if (service.id === 3) {
            return (
              <ClosableLink
                closed={isClosedNow(service)}
                to={`/${params.room_uuid}/hotel-services/laundry/${
                  service.link.split(`${params.room_uuid}/laundry/`)[1]
                }`}
                onClick={() =>
                  trackCategoryViewed({
                    category_id: 3,
                    category_name: service?.display_name || "",
                    category_type: "Laundry",
                  })
                }
              >
                <img
                  src={
                    isSaudi
                      ? laundryImage
                      : `https://d3l5wxnahfuscp.cloudfront.net/static/Laundry.png`
                  }
                  alt=""
                  className="service_img"
                />
                <img src={Overllay} alt="" className="overlay" />
                <h6 className="sub_title">{service?.display_name}</h6>
              </ClosableLink>
            );
          }
          if (service.id === 5) {
            return (
              <ClosableLink
                closed={isClosedNow(service)}
                to={`/${params.room_uuid}/hotel-services/houseKeeping`}
                onClick={() =>
                  trackCategoryViewed({
                    category_id: 5,
                    category_name: service?.display_name || "",
                    category_type: "Housekeeping",
                  })
                }
              >
                <img
                  src={
                    isSaudi
                      ? housekeepingImage
                      : `https://d3l5wxnahfuscp.cloudfront.net/static/Housekeeping.png`
                  }
                  alt=""
                  className="service_img"
                />
                <img src={Overllay} alt="" className="overlay" />
                <h6 className="sub_title">{service?.display_name}</h6>
              </ClosableLink>
            );
          }
          if (service.id === 15) {
            return (
              <ClosableLink
                closed={isClosedNow(service)}
                to={`/${params.room_uuid}/maintenance/companies`}
                onClick={() =>
                  trackCategoryViewed({
                    category_id: 15,
                    category_name: service?.display_name || "",
                    category_type: "Maintenance",
                  })
                }
              >
                <img
                  src={
                    "https://d3l5wxnahfuscp.cloudfront.net/static/Maintenance.png"
                  }
                  alt=""
                  className="service_img"
                />
                <img src={Overllay} alt="" className="overlay" />
                <h6 className="sub_title">{service?.display_name}</h6>
              </ClosableLink>
            );
          }
          if (service.id === 7) {
            return (
              <ClosableLink
                closed={isClosedNow(service)}
                to={`/${params.room_uuid}/hotel-services/conceirge`}
                onClick={() =>
                  trackCategoryViewed({
                    category_id: 7,
                    category_name: service?.display_name || "",
                    category_type: "Concierge",
                  })
                }
              >
                <img
                  src={
                    isSaudi
                      ? receptionImage
                      : "https://d3l5wxnahfuscp.cloudfront.net/static/Conceirge.png"
                  }
                  alt=""
                  className="service_img"
                />
                <img src={Overllay} alt="" className="overlay" />
                <h6 className="sub_title">{service?.display_name}</h6>
              </ClosableLink>
            );
          }
        })}
      </div>
      <NewFooter />
    </div>
  );
};

export default HotelServices;
